import cn from "@/utils/cn"
import { ComponentPropsWithoutRef } from "react"

type PatientDataCellProps = ComponentPropsWithoutRef<"div">

const DataCell = ({
  className,
  children,
  ...otherProps
}: PatientDataCellProps) => (
  <div
    className={cn(
      "flex items-center justify-start overflow-hidden py-3 font-medium text-primary/90",
      className
    )}
    {...otherProps}
  >
    {children}
  </div>
)

export default DataCell
